import React from "react";
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { formatDecimal } from "../../utils/numberFormat";

const COLORS = ["#2563EB", "#7C3AED", "#059669", "#D97706", "#DC2626", "#0891B2"];

function UsageByCategoryChart({ data, dataKey = "cost_consumed", nameKey = "category_name" }) {
  if (!data?.length) {
    return <div style={{ padding: 32, textAlign: "center", color: "#9CA3AF", fontSize: 14 }}>No data available</div>;
  }
  // The slice value arrives as a raw DECIMAL string from the API - coerce to
  // a number so recharts computes slice sizes correctly, not just display.
  const chartData = data.map((d) => ({ ...d, [dataKey]: Number(d[dataKey]) }));
  return (
    <ResponsiveContainer width="100%" height={260}>
      <PieChart>
        <Pie
          data={chartData}
          dataKey={dataKey}
          nameKey={nameKey}
          cx="50%"
          cy="50%"
          outerRadius={90}
          label={(entry) => formatDecimal(entry.value)}
        >
          {chartData.map((_, idx) => (
            <Cell key={idx} fill={COLORS[idx % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip
          contentStyle={{ background: "#fff", border: "1px solid #E5E7EB", borderRadius: 8, fontSize: 12 }}
          formatter={(value) => formatDecimal(value)}
        />
        <Legend wrapperStyle={{ fontSize: 12, color: "#6B7280" }} />
      </PieChart>
    </ResponsiveContainer>
  );
}

export default UsageByCategoryChart;
